<template>
    <v-row justify="center">
        <v-tabs centered>
            <v-tab>Revenue</v-tab>
            <v-tab>Payroll</v-tab>

            <v-tab-item class="mx-5">
                <v-col cols="12">
                    <v-data-table
                        :headers="transHeadersRev"
                        :items="filteredItemsRev"
                        fixed-header
                        height="600px"
                        dense
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-row>
                                <v-col cols="4">
                                    <v-combobox
                                        v-model="customer"
                                        placeholder="Select Customer"
                                        class="mx-3"
                                        label="Customer"
                                        :items="customers"
                                        dense
                                        hide-details
                                        :item-text="'Customer'"
                                        :item-value="'id'"
                                        auto-select-first
                                    ></v-combobox>
                                </v-col>
                                <v-col cols="8">
                                    <v-btn
                                        color="secondary"
                                        icon
                                        @click="ShowTransacted"
                                        class="my-auto mr-5"
                                        ><v-icon>mdi-refresh</v-icon></v-btn
                                    >
                                    <v-btn
                                        color="success"
                                        small
                                        class="my-auto mr-2"
                                        @click="downloadExcelByShift"
                                        >Export
                                        <v-icon
                                            >mdi-microsoft-excel</v-icon
                                        ></v-btn
                                    >
                                    <v-btn
                                        color="primary"
                                        small
                                        class="my-auto ml-2"
                                        @click="
                                            $store.state.newTransact.exceptionRev = true
                                        "
                                        >Exceptions</v-btn
                                    >
                                    <!-- <v-btn icon left class="my-auto mr-2"
                                @click="ShowTransacted"><v-icon>mdi-reload</v-icon></v-btn> -->

                                    <v-btn
                                        small
                                        left
                                        class="my-auto ml-2"
                                        @click="transactedOrders('Revenue')"
                                        ><v-icon>mdi-content-save</v-icon> Save
                                        Orders</v-btn
                                    >
                                    <v-btn
                                        small
                                        left
                                        class="my-auto ml-2"
                                        @click="FinalizeShifts"
                                        ><v-icon>mdi-clock-check</v-icon>
                                        Finalizar Shift</v-btn
                                    >
                                    <v-btn
                                        icon
                                        left
                                        class="my-auto ml-2 float-right"
                                        @click="
                                            $store.state.newTransact.all = !$store
                                                .state.newTransact.all
                                        "
                                        ><v-icon>mdi-arrow-left</v-icon></v-btn
                                    >
                                </v-col>
                            </v-row>
                            <v-toolbar color="primary" dense dark>
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text">
                                    Revenue
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>

                        <template v-slot:item.ShiftDetail="{ item }">
                            <v-btn
                                color="primary"
                                small
                                @click="GotoTransact(item)"
                                >{{ item.ShiftDetail }}</v-btn
                            >
                        </template>
                    </v-data-table>
                </v-col>
            </v-tab-item>

            <v-tab-item class="mx-5">
                <v-col cols="12">
                    <v-data-table
                        :headers="transHeadersPay"
                        :items="filteredItemsPay"
                        fixed-header
                        height="600px"
                        dense
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-row>
                                <v-col cols="4">
                                    <v-combobox
                                        v-model="truck"
                                        placeholder="Select truck"
                                        class="mx-3"
                                        label="Truck"
                                        :items="trucks"
                                        dense
                                        hide-details
                                        :item-text="'Truck'"
                                        :item-value="'id'"
                                        auto-select-first
                                    ></v-combobox>
                                </v-col>
                                <v-col cols="8">
                                    <v-btn
                                        color="secondary"
                                        icon
                                        @click="ShowTransacted"
                                        class="my-auto mr-5"
                                        ><v-icon>mdi-refresh</v-icon></v-btn
                                    >
                                    <v-btn
                                        color="success"
                                        small
                                        class="my-auto mr-2"
                                        @click="downloadExcelByShiftsPay"
                                        >Export
                                        <v-icon
                                            >mdi-microsoft-excel</v-icon
                                        ></v-btn
                                    >
                                    <v-btn
                                        color="primary"
                                        small
                                        class="my-auto ml-2"
                                        @click="
                                            $store.state.newTransact.exceptionPay = true
                                        "
                                        >Exceptions</v-btn
                                    >
                                    <!-- <v-btn icon left class="my-auto mr-2"
                                @click="ShowTransacted"><v-icon>mdi-reload</v-icon></v-btn> -->

                                    <v-btn
                                        small
                                        left
                                        class="my-auto ml-2"
                                        @click="transactedOrders('Payroll')"
                                        ><v-icon>mdi-content-save</v-icon> Save
                                        Orders</v-btn
                                    >
                                    <v-btn
                                        small
                                        left
                                        class="my-auto ml-2"
                                        @click="FinalizeShifts"
                                        ><v-icon>mdi-clock-check</v-icon>
                                        Finalizar Shift</v-btn
                                    >
                                    <v-btn
                                        icon
                                        left
                                        class="my-auto mr-2 float-right"
                                        @click="
                                            $store.state.newTransact.all = !$store
                                                .state.newTransact.all
                                        "
                                        ><v-icon>mdi-arrow-left</v-icon></v-btn
                                    >
                                </v-col>
                            </v-row>
                            <v-toolbar color="primary" dense dark>
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text">
                                    Payroll
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.ShiftDetail="{ item }">
                            <v-btn
                                color="primary"
                                small
                                @click="GotoTransact(item)"
                                >{{ item.ShiftDetail }}</v-btn
                            >
                        </template>
                    </v-data-table>
                </v-col>
            </v-tab-item>
        </v-tabs>
        <exceptionRev
            v-if="$store.state.newTransact.exceptionRev"
            :exeptions="exeptions"
            :Shifts="ShiftDetails"
            :customer="customer"
        ></exceptionRev>

        <exceptionPay
            v-if="$store.state.newTransact.exceptionPay"
            :exeptions="exeptions"
            :Shifts="ShiftDetails"
        >
        </exceptionPay>

        <transacting
            v-if="$store.state.newTransact.transacting"
            :searchShift="shift"
        ></transacting>
    </v-row>
</template>
<script>
import axios from 'axios';
import exceptionRev from './../../Modals/Administration/Transacting/Revenue/Exception.vue';
import exceptionPay from './../../Modals/Administration/Transacting/Payroll/Exception.vue';
import transacting from './../../Modals/Administration/Transacting/TransactingModal.vue';
export default {
    props: ['data', 'headers', 'Shifts'],
    components: {
        exceptionRev,
        exceptionPay,
        transacting
    },
    data: function() {
        return {
            transactions: [],
            transHeadersRev: [
                { text: 'Order', value: 'OrderNumber', width: '5%' },
                { text: 'ShiftDetail', value: 'ShiftDetail', width: '4%' },
                { text: 'BOL', value: 'BillOfLading' },
                { text: 'L1', value: 'LoadNum', width: '1%' },
                { text: 'L2', value: 'LoadNumOrd', width: '1%' },
                {
                    text: 'DateTerminalPick',
                    value: 'DateTerminalPick',
                    width: '20%'
                },
                { text: 'Shift', value: 'Shift', width: '10%' },
                { text: 'Terminal', value: 'TerminalName', width: '20%' },
                { text: 'Station', value: 'Station', width: '20%' },
                { text: 'City', value: 'City' },
                {
                    text: 'Transaction Type',
                    value: 'TranTypeName',
                    width: '20%'
                },
                { text: 'Product', value: 'Product', width: '10%' },
                { text: 'Qty', value: 'Quantity', width: '10%' },
                { text: 'Rate', value: 'Rate', width: '10%' },
                { text: 'Amount', value: 'Amount', width: '10%' }
            ],
            transHeadersPay: [
                { text: 'Order', value: 'OrderNumber', width: '5%' },
                { text: 'ShiftDetail', value: 'ShiftDetail', width: '4%' },
                { text: 'Truck', value: 'Truck', width: '10%' },
                { text: 'BOL', value: 'BillOfLading' },
                { text: 'L1', value: 'LoadNum', width: '1%' },
                { text: 'L2', value: 'LoadNumOrd', width: '1%' },
                { text: 'Date', value: 'Date', width: '20%' },
                { text: 'Shift', value: 'Shift', width: '10%' },
                { text: 'Terminal', value: 'TerminalName', width: '20%' },
                { text: 'Station', value: 'Station', width: '20%' },
                { text: 'City', value: 'City' },
                {
                    text: 'Transaction Type',
                    value: 'TranTypeName',
                    width: '20%'
                },
                { text: 'Product', value: 'Product', width: '10%' },
                { text: 'Qty', value: 'Quantity', width: '10%' },
                { text: 'Rate', value: 'Rate', width: '10%' },
                { text: 'Amount', value: 'Amount', width: '10%' }
            ],
            customers: [],
            ShiftDetails: [],
            customer: null,
            view: this.transacts,
            transactionsRev: [],
            transactionsPay: [],

            trucks: [],
            truck: null
        };
    },
    computed: {
        filteredItemsRev() {
            return this.transactionsRev.filter(i => {
                return !this.customer || i.CustomerID == this.customer.id;
            });
        },
        filteredItemsPay() {
            return this.transactionsPay.filter(i => {
                return !this.truck || i.TruckID == this.truck.id;
            });
        }
    },
    mounted() {
        this.ShiftDetails = this.Shifts;
        this.ShowTransacted();
    },
    methods: {
        GotoTransact: function(item) {
            this.$store.state.newTransact.transacting = true;
            this.shift = item.ShiftDetail;
        },
        FinalizeShifts: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Orders: this.orders
            };
            axios
                .post('new-transaction/finalize/shift', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Shifts successfully completed'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        transactedOrders: function(itm) {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Orders: this.orders,
                Type: itm
            };
            axios
                .post('new-transaction/update/orders', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Shifts successfully completed'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        ShowTransacted: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                // ShiftDetails: this.Shifts,
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Customer: null,
                Truck: null,
                Export: 0
            };
            axios
                .post('new-transaction/transacted/all', parms)
                .then(async response => {
                    this.transactionsRev = response.data['revenue'];
                    this.transactionsPay = response.data['payroll'];
                    this.filterCustomers();
                    this.filterTrucks();
                    this.filterOrders();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        filterTrucks: function() {
            const trucks = this.transactionsPay.map(x => {
                return {
                    id: x.TruckID,
                    Truck: x.Truck
                };
            });
            this.trucks = this.eliminarDuplicados(trucks);
            console.log(trucks);
        },
        filterOrders: function() {
            var orders = this.transactionsRev.map(x => {
                return x.OrderNumber;
            });
            this.orders = this.eliminarDuplicados(orders);
            console.log(this.orders, orders);
        },
        filterCustomers: function() {
            const customers = this.transactionsRev.map(x => {
                return {
                    id: x.CustomerID,
                    Customer: x.Customer
                };
            });
            this.customers = this.eliminarDuplicados(customers);
            // this.customer = this.customers[0];
            console.log(customers);
        },
        eliminarDuplicados: function(arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },

        getOrdertoTransactNotPost: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
            };
            axios
                .post('new-transaction/not-post', parms)
                .then(async response => {
                    this.orders = response.data;
                    this.$store.state.newTransact.NotPost = true;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getExceptions: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate')
                // Customer: this.customer.id,
            };
            axios
                .post('new-transaction/exceptions', parms)
                .then(async response => {
                    this.exeptions = response.data;
                    this.$store.state.newTransact.exception = true;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        downloadExcelByShift: async function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Export: 1,
                Customer: this.customer
            };
            str.state.isLoading = true;
            axios
                .post('new-transaction/transacted', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Transactions.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        downloadExcelByShiftsPay: async function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Export: 1,
                Truck: this.truck
            };
            str.state.isLoading = true;
            axios
                .post('new-transaction/transacted/payroll', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Transactions.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>
